module.exports = __webpack_public_path__ + "static/media/hive_balls.64d64337.png";